import { useCallback, useRef } from 'react';
export const useTimer = () => {
  const startTime = useRef(0);
  const start = useCallback(() => {
    startTime.current = performance.now();
  }, []);
  const stop = useCallback(() => {
    if (startTime.current === 0) {
      return null;
    }
    const time = Math.round(performance.now() - startTime.current);
    startTime.current = 0;
    return time;
  }, []);
  return {
    start,
    stop
  };
};